// AsciiEncoderDecoder.js
const EncodeStringToAscii = (str) => {
    if (!str || typeof str !== 'string') {
        console.error("Invalid input. Please provide a valid string.");
        return '';
    }
    const encodedArray = str.split('').map(char => char.charCodeAt(0));
    return encodedArray.join('-'); // Use any separator you like
};


const DecodeStringFromAscii = ( encodedStr ) => {
    if (!encodedStr) {
        console.error("Encoded string is undefined or empty.");
        return '';
    }
    const encodedArray = encodedStr.split('-');
    const decodedString = encodedArray.map(code => String.fromCharCode(parseInt(code, 10))).join('');
    return decodedString;
};

export { EncodeStringToAscii, DecodeStringFromAscii };
